import React from "react";
import { useLocation } from "react-router-dom";
// import RegisterForm from "../_auth/RegisterForm";
import MainRegistrationForm from "../_auth/registration/MainRegistrationForm";

const SignUpPage = () => {
  const location = useLocation();
  
  // Get the selected tab from navigation state, default to 'Buyer' if not present
  const selectedTab = location.state?.selectedTab || 'Buyer';
  
  // const handleRegister = async (formData) => {
  //   // Handle login logic here
  //   // Example: await authService.login(formData);
  // };
  return (
    <div>
      {/* <RegisterForm
        type="register"
        onSubmit={handleRegister}
        tabs={["Buyer", "Seller"]}
        defaultTab="Buyer"
      /> */}
      <MainRegistrationForm tabs={["Seller", "Buyer"]} defaultTab={selectedTab} />
    </div>
  );
};

export default SignUpPage;
